/**
 * Data cy attribute
 */
export const DATA_CY = "data-cy";
export const EDIT_LIST_DATA_CY_SUFFIX = "_editList";
export const SMART_LIST_DATA_CY_SUFFIX = "_smartList";

/**
 * Add dataCy value on element
 */
export function addDataCy(element: HTMLElement, value: string): void {
    element.setAttribute(DATA_CY, value);
} 